"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonld_context_parser_1 = require("jsonld-context-parser");

var ContextTree_1 = require("./ContextTree");

var JsonLdParser_1 = require("./JsonLdParser");
/**
 * Data holder for parsing information.
 */


var ParsingContext =
/*#__PURE__*/
function () {
  function ParsingContext(options) {
    var _this = this;

    _classCallCheck(this, ParsingContext);

    // Initialize settings
    this.contextParser = new jsonld_context_parser_1.ContextParser({
      documentLoader: options.documentLoader
    });
    this.allowOutOfOrderContext = options.allowOutOfOrderContext;
    this.baseIRI = options.baseIRI;
    this.produceGeneralizedRdf = options.produceGeneralizedRdf;
    this.allowSubjectList = options.allowSubjectList;
    this.processingMode = options.processingMode || JsonLdParser_1.JsonLdParser.DEFAULT_PROCESSING_MODE;
    this.errorOnInvalidProperties = options.errorOnInvalidIris;
    this.validateValueIndexes = options.validateValueIndexes;
    this.defaultGraph = options.defaultGraph; // Initialize stacks

    this.processingStack = [];
    this.emittedStack = [];
    this.idStack = [];
    this.graphStack = [];
    this.listPointerStack = [];
    this.contextTree = new ContextTree_1.ContextTree();
    this.literalStack = [];
    this.validationStack = [];
    this.unaliasedKeywordCacheStack = [];
    this.unidentifiedValuesBuffer = [];
    this.unidentifiedGraphsBuffer = [];
    this.parser = options.parser;

    if (options.context) {
      this.rootContext = this.contextParser.parse(options.context, {
        baseIri: options.baseIRI
      });
      this.rootContext.then(function (context) {
        return _this.validateContext(context);
      });
    } else {
      this.rootContext = Promise.resolve(this.baseIRI ? {
        '@base': this.baseIRI
      } : {});
    }

    this.topLevelProperties = false;
  }
  /**
   * Check if the given context is valid.
   * If not, an error will be thrown.
   * @param {IJsonLdContextNormalized} context A context.
   */


  _createClass(ParsingContext, [{
    key: "validateContext",
    value: function validateContext(context) {
      var activeVersion = context['@version'];

      if (activeVersion && parseFloat(activeVersion) > parseFloat(this.processingMode)) {
        throw new Error("Unsupported JSON-LD processing mode: ".concat(activeVersion));
      }
    }
    /**
     * Get the context at the given path.
     * @param {keys} keys The path of keys to get the context at.
     * @param {number} offset The path offset, defaults to 1.
     * @return {Promise<IJsonLdContextNormalized>} A promise resolving to a context.
     */

  }, {
    key: "getContext",
    value: function getContext(keys) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (offset) {
        keys = keys.slice(0, -offset);
      }

      return this.contextTree.getContext(keys) || this.rootContext;
    }
    /**
     * Start a new job for parsing the given value.
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @return {Promise<void>} A promise resolving when the job is done.
     */

  }, {
    key: "newOnValueJob",
    value: function () {
      var _newOnValueJob = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(keys, value, depth) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.parser.newOnValueJob(keys, value, depth);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function newOnValueJob(_x, _x2, _x3) {
        return _newOnValueJob.apply(this, arguments);
      }

      return newOnValueJob;
    }()
    /**
     * Emit the given quad into the output stream.
     * @param {number} depth The depth the quad was generated at.
     * @param {Quad} quad A quad to emit.
     */

  }, {
    key: "emitQuad",
    value: function emitQuad(depth, quad) {
      if (depth === 1) {
        this.topLevelProperties = true;
      }

      this.parser.push(quad);
    }
    /**
     * Emit the given error into the output stream.
     * @param {Error} error An error to emit.
     */

  }, {
    key: "emitError",
    value: function emitError(error) {
      this.parser.emit('error', error);
    }
    /**
     * Emit the given context into the output stream under the 'context' event.
     * @param {JsonLdContext} context A context to emit.
     */

  }, {
    key: "emitContext",
    value: function emitContext(context) {
      this.parser.emit('context', context);
    }
    /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedValuesBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedValuesBuffer}.
     */

  }, {
    key: "getUnidentifiedValueBufferSafe",
    value: function getUnidentifiedValueBufferSafe(depth) {
      var buffer = this.unidentifiedValuesBuffer[depth];

      if (!buffer) {
        buffer = [];
        this.unidentifiedValuesBuffer[depth] = buffer;
      }

      return buffer;
    }
    /**
     * Safely get or create the depth value of {@link ParsingContext.unidentifiedGraphsBuffer}.
     * @param {number} depth A depth.
     * @return {{predicate: Term; object: Term; reverse: boolean}[]} An element of
     *                                                               {@link ParsingContext.unidentifiedGraphsBuffer}.
     */

  }, {
    key: "getUnidentifiedGraphBufferSafe",
    value: function getUnidentifiedGraphBufferSafe(depth) {
      var buffer = this.unidentifiedGraphsBuffer[depth];

      if (!buffer) {
        buffer = [];
        this.unidentifiedGraphsBuffer[depth] = buffer;
      }

      return buffer;
    }
  }]);

  return ParsingContext;
}();

exports.ParsingContext = ParsingContext;